module.exports = __webpack_public_path__ + "media/images/u-icon-d104ce46c5e8f205de351d8cc09caf0e.svg";